var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoldIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.903 5.522a3.02 3.02 0 0 0 .847-2.099v-.159C8.75 1.583 7.373.22 5.677.22H1.053a.429.429 0 0 0-.428.428v10.61a.46.46 0 0 0 .46.462h4.98a3.299 3.299 0 0 0 3.31-3.29v-.171c0-1.14-.584-2.145-1.472-2.736zM2.125 1.719h3.51c.893 0 1.615.694 1.615 1.551v.149c0 .856-.723 1.551-1.614 1.551H2.125V1.72zm5.728 6.71c0 .982-.808 1.779-1.805 1.779H2.125V6.48h3.923c.997 0 1.805.797 1.805 1.78v.168z",
    fill: "#000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoldIcon);
export default __webpack_public_path__ + "static/media/boldIcon.77d6e6f329adbbefe2f7c69c9ba5cc79.svg";
export { ForwardRef as ReactComponent };